import { useToken } from '@chakra-ui/react';
import { GroupBase, StylesConfig } from 'react-select';

interface UseSelectStylesProps {
  isLargerThanBreakpoint: boolean;
}

interface SelectOption {
  label?: string;
  value?: string;
}

export default function useSelectStyles<
  Option extends SelectOption = SelectOption,
>({
  isLargerThanBreakpoint,
}: UseSelectStylesProps): StylesConfig<Option, false, GroupBase<Option>> {
  const [white, black, gray200, gray300, orange400, orange100] = useToken(
    'colors',
    ['white', 'black', 'gray.200', 'gray.300', 'orange.400', 'orange.100'],
  ) as [string, string, string, string, string, string];

  const [space4] = useToken('space', ['4']) as [string];

  return {
    container: (styles) => ({
      ...styles,
      minWidth: '16rem',
      width: isLargerThanBreakpoint ? '25%' : '100%',
    }),
    control: (styles, { selectProps: { isDisabled } }) => ({
      ...styles,
      backgroundColor: white,
      borderColor: gray200,
      borderRadius: 0,
      borderWidth: 1,
      boxShadow: 'none',
      cursor: isDisabled ? 'not-allowed' : 'initial',
      height: isLargerThanBreakpoint ? '3.125rem' : '2.5rem',
      width: '100%',
      '&:hover': {
        borderColor: gray300,
      },
      '&:focus-within': {
        borderColor: orange400,
      },
    }),
    placeholder: (styles) => ({
      ...styles,
      color: gray300,
    }),
    menu: (styles) => ({
      ...styles,
      borderRadius: 0,
      marginTop: 0,
    }),
    option: (styles, { isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? orange400 : white,
      '&:hover': {
        backgroundColor: isSelected ? orange400 : orange100,
        color: isSelected ? white : black,
      },
    }),
    valueContainer: (styles, { selectProps: { isDisabled } }) => ({
      ...styles,
      cursor: isDisabled ? 'not-allowed' : 'initial',
      paddingLeft: space4,
    }),
  };
}
